<template>
  <div class="tv-addons">
    <transition name="fade" mode="out-in">
      <!-- TODO dodati on error stanje i retry event -->
      <loader-with-message v-if="dataLoading" :key="'loader'" />
      <addon-list v-else-if="Object.keys(televisionAddonList).length && !dataLoading"
                  list-type="tv"
                  ref="addonList"
                  :addon-data="[televisionAddonList]"
                  @view-channels="getChannelsInPackage"
                  @confirm-activation="activateAddonsApi"
                  @confirm-deactivation="deactivateAddonsApi"/>

      <div v-else
           :key="'no-addons'"
           class="no-addons">
        <img src="/assets/images/no-results.svg" width="112" height="112" alt=""/>
        <h3 class="title">{{ $t('addons.noAddonsTitle') }}</h3>
      </div>
    </transition>

    <modal :visible="channelListVisible"
           size="md"
           class="addons-channel-modal"
           @modal-close="channelListVisible = false">
      <base-inline-loader v-if="channelDataLoading"/>
      <television-channel-list v-else
                               :channel-data="channelData"
                               :package-name="selectedPackageName"
                               :show-channel-count="false"
                               :total-channels="selectedPackageChannels"/>
    </modal>
  </div>
</template>

<script>
import errorMessageHandler from '@/mixins/errorMessageHandler'
import AddonList from '@/components/addons/addon-list'
import Modal from '@/components/common/modal/modal'
import TelevisionChannelList from '@/components/services/resources/television-channel-list'
import { makeQueryString } from '@/utils/queryParser'
import addonsActivation from '@/mixins/addonsActivation'
import selectionBlockEvents from '@/mixins/selectionBlockEvents'
import LoaderWithMessage from '@/components/common/loader-with-message'

export default {
  name: 'tv-addons',
  components: { LoaderWithMessage, TelevisionChannelList, Modal, AddonList },
  props: {
    resourcesData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data () {
    return {
      dataLoading: true,
      televisionAddonList: [],
      channelListVisible: false,
      channelData: [],
      selectedPackageName: '',
      channelDataLoading: false,
      selectedPackageChannels: 0,
      confirmationLoader: false
    }
  },
  mixins: [errorMessageHandler, addonsActivation, selectionBlockEvents],
  methods: {
    fetchAddons () {
      this.dataLoading = true
      const id = this.$props.resourcesData.subscriberIdentity

      if (!id) return

      this.$apiRequest.get('/user/services/addons/tv?subscriberIdentity=' + id)
        .then(response => {
          this.televisionAddonList = response.data || []
        })
        .catch(e => {
          this.handleErrorMessage(e.response.data)
        })
        .finally(() => {
          this.dataLoading = false
          this.$nextTick(() => {
            this.unblockSidebarSelection(false)
          })
        })
    },
    getChannelsInPackage (data) {
      this.channelDataLoading = true
      const { subscriberIdentity } = this.$props.resourcesData
      const qs = makeQueryString({ packageCode: data.code, subscriberIdentity: subscriberIdentity })
      this.selectedPackageName = data.name
      this.selectedPackageChannels = data.channelsAmount
      this.channelListVisible = true

      this.$apiRequest.get(`user/service/tvchannels${qs}`)
        .then(response => {
          this.channelData = response.data.categories || []
        })
        .catch(e => {
          this.handleErrorMessage(e.response.data)
        })
        .finally(() => {
          this.channelDataLoading = false
        })
    }
  },
  mounted () {
    this.fetchAddons()
  }
}
</script>

<style scoped lang="scss">
.tv-addons {
  padding: 2rem 0 4rem;
}
</style>
